import React from "react";

import cx from "classnames";

import styles from "./CardPadding.scss";

/**
 * Card Padding
 *
 * This component wraps children with horizontal padding that is consistent
 * with the Card component, for cases where we don't want vertical padding.
 */
export function CardPadding({
  size = 24,
  className,
  children,
}: CardPaddingProps) {
  const classNames = cx(className, styles[`card-padding--${size}`]);
  return <div className={classNames}>{children}</div>;
}

export type CardPaddingProps = React.PropsWithChildren<{
  size?: 8 | 12 | 16 | 20 | 24 | 32;
  className?: string;
}>;
